
import { useQuery } from "@tanstack/react-query";
import { startDistribucionXLote, startLoteDistriXID } from "../../../services";






export const useLoteDistriXID = (id) => {
    const loteDistriXIDQuery = useQuery({
        queryKey: ['distribucion-id', id], 
        queryFn: () => startLoteDistriXID(id),
    });

    return {
        loteDistriXIDQuery
    }
}



export const useDistribucionXLote = (id) => {
    const distribucionXLoteQuery = useQuery({
        queryKey: ['distri-xlote', id], 
        queryFn: () => startDistribucionXLote(id),
    });

    return {
        distribucionXLoteQuery,
    }
}

